import React, {Component, PropTypes } from 'react'
import cookie from 'react-cookie'
import Layout from '../components/componentKit2/Layout'
import {api} from '../config.js'
import CSSModules from 'react-css-modules'
import styles from './errorReport.css'
import Modal from 'boron/FadeModal'
import {connect} from 'react-redux'
import {Link, browserHistory} from 'react-router'

let contentStyle = {
  borderRadius: '18px',
  padding: '45px 20px',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '340px',
  textAlign: 'center'
}
const modalStyle={
  maxWidth: '500px',
  width: '90%'
}
/**
 *  Контейнер ErrorReport.
 *  Используется для отображения страницы Нашел ошибку? (/error-report)
 *
 */
class ErrorReport extends Component {

  state = {
    /**
     * Текст ошибки
     * @memberof ErrorReport
     */
    text: '',
    /**
     * Массив скриншотов или видео
     * @memberof ErrorReport
     */
    docs:[]
  }

  onChangeText(event) {
    this.setState({
      text: event.target.value
    })
  }

  onChangeFile(event) {
    const {target} = event
    this.refs.loadingModal.show()
    if (target.files && target.files[0]) {
      var reader = new FileReader()
      reader.onload = e => {
        let content
        if(reader.result.indexOf('data:video') !== -1){
          content = reader.result.replace(/data:video\/\w+;base64,/, '')
        } else {
          content = reader.result.replace(/data:image\/\w+;base64,/, '')
        }

         const name = target.files[0].name
         const payload = {
           authToken: cookie.load('token'),
           data: {
             name,
             content
           }
         }
        const headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
        return fetch(`${api}/data/file-upload`, {
          headers,
          method: 'POST',
          body: JSON.stringify(payload)
        })
          .then(response => response.json())
          .then(json => {
            this.refs.loadingModal.hide()
            this.setState({
              docs: this.state.docs.concat({
                name:name,
                uid: json.data.uid
              })
            })
          })
      }
      reader.readAsDataURL(target.files[0])
    }
  }

  send() {
    if (!this.state.docs.length && !this.state.text) return;
    this.refs.loadingModal.show()
    const uids = this.state.docs.map(item => item.uid)
    const payload = {
      authToken: cookie.load('token'),
      data: {
        message: this.state.text,
       // email: this.state.email,
        //name: this.state.name,
        screenshots: uids
      }
    };
    return fetch(`${api}/data/errorReport-create`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(json => {
        this.refs.loadingModal.hide()
        if (json.errorCode === 1) {
          this.refs.successModal.show()
          this.setState({
           // screenshotsName: [],
            //email: '',
            //name: '',
            text: '',
            docs: []
           // screenshots: []
          })
        } else {
          this.refs.errorModal.show()
        }
      })
  }

  onRemove(doc){
    this.setState({
      docs: this.state.docs.filter(item => item.uid !== doc.uid)
    })
    this.refs.error.value = ''
  }

  render() {
    const {userInfo, location} = this.props;
    console.log(this.props)
    console.log('errorrrr')
    return (
      <Layout location={location} pageNumber={9} prevSeasons={userInfo.data.prevSeasons}>
        <div className="stage-box stage-box--small-padding">
          <div className="stage-box__inner">
            <div className={styles.top}>
              <div className={styles.topInfo}>
                <div className={styles.title}>Возникли трудности?</div>
                <p>Недосчитались баллов?</p>
                <p>Хотите уточнить нюансы выполнения экзаменов?</p>
                <p>Есть аспекты, которые вызывают затруднения в выполнении физической нагрузки?</p>
                <p><span className={styles.bold}>Адресуйте все ваши вопросы</span> в специальный <span><Link to="/chats">чат с тренером!</Link></span></p>
              </div>
              <div className={styles.topBtn}>
                <button
                  className="btn btn--primary"
                  type="button"
                  onClick={() => browserHistory.push('/chats')}
                >Написать
                </button>
              </div>
            </div>
         {/*   <h2 className="h1 text-center mb10">Отчет об ошибке</h2>
            <p className="sub-title">К сожалению, на нашем ресурсе иногда встречаются ошибки или неточности, поэтому мы
              будем благодарны Вам за сообщение об ошибке.</p>*/}
         <div className={styles.main}>
           <div className={styles.title}>Мы рады вашим предложениям и пожеланиям!</div>
           <p>За время марафона вы прислали более 2300 писем с предложениями на тему того, как улучшить наш марафон! Самые важные из них уже приведены в исполнение, ещё с десяток ждут реализации в обновлённой версии платформы Наздоровье2.0. Мы невероятно благодарны за вашу активность - и продолжаем начислять по 1 баллу за каждое конструктивное пожелание, которое сделает марафон лучше! </p>
           <div className={styles.bold}><span>Смело пишите свои предложения, если вы:</span></div>
           <p>* нашли ошибку технического плана - например, связанную с вёрсткой сайта, некорректным отображением элементов и иные баги (ошибки в тексте контента или в начислении баллов не в счёт - адресуйте это в <span><Link to="/chats">тренерский чат</Link></span>) </p>
           <p>* уверены, что знаете, как сделать жизнь 1500 пользователей  на платформе легче и лучше</p>
           <p>Мы ждём ваших идей!</p>
         </div>

            <div className="textarea mb30">
            <textarea
              className="textarea__field"
              name="text"
              placeholder="Введите ваше предложение по улучшению марафона.Лучшие идеи буду награждены баллом"
              value={this.state.text}
              onChange={(event) => this.onChangeText(event)}
            />
            </div>
            {
              this.state.docs.map((item, index) => {
                return (
                  <div className={styles.doneList} key={index}>
                    <span className={styles.listName}>{item.name}</span>
                    <span className={styles.listNameIcons}>
                      <span>
                        <svg className={styles.svgIcoDone}>
                          <use xlinkHref="#ico-big-done"></use>
                        </svg>
                      </span>
                      <span className={styles.trash}  onClick={() => this.onRemove(item)}>
                        <svg className="svg-icon ico-trash">
                          <use xlinkHref="#ico-trash"></use>
                        </svg>
                      </span>
                    </span>
                  </div>
                )
              })
            }
            <div className="input input--btn">
              <span className="input__text">Скриншот или видео</span>
              <input
                multiple=""
                type="file"
                ref="error"
              /*  accept="image/!*"*/
                id="file-upload"
                className="input__field"
                placeholder=""
                onChange={(event) => this.onChangeFile(event)}
              />
              <label
                htmlFor="file-upload"
                className="btn btn--base"
              >Прикрепить файл</label>
            </div>

            <p className="text-center">
              <button
                className="btn btn--primary"
                type="button"
                onClick={() => this.send()}
              >Отправить сообщение
              </button>
            </p>

          </div>
          <Modal ref='loadingModal' contentStyle={contentStyle}>
            <div className={styles.entryHeader}>
              <h2 className={styles.entryTitleCenter}>Загружается...</h2>
            </div>
            <div className={styles.textCenter}>
              <div className={styles.loaderMain}></div>
            </div>
          </Modal>

          <Modal ref='errorModal' modalStyle={modalStyle} contentStyle={contentStyle}>
            <h2>Что-то пошло не так, попробуйте снова</h2>
            <br/>
            <button className={styles.btnAction} onClick={() => {
              this.refs.errorModal.hide()
            }}>
              Продолжить
            </button>
          </Modal>
          <Modal ref='successModal' modalStyle={modalStyle} contentStyle={contentStyle}>
            <h2>Спасибо!</h2>
            <br/>
            <button className={styles.btnAction} onClick={() => {
              this.refs.successModal.hide()
            }}>
              Продолжить
            </button>
          </Modal>

        </div>
      </Layout>
    )
  }
}
const mapStateToProps = state => {
  const {userInfo} = state;
  return {
    userInfo
  }
};
ErrorReport = connect(
  mapStateToProps
)(ErrorReport);
export default CSSModules(ErrorReport, styles)



// WEBPACK FOOTER //
// /var/www/build-health-2/src/containers/ErrorReport.js